
 import util from './util.js'
 //格式化文件大小显示
export function dataURLtoBlob(dataurl) {//base64转blob
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

//格式化时间
export function formatTime(cellValue,formate){
    if(cellValue == null){
        return "";
    }
    if(formate == null){
        formate = "yyyy-MM-dd hh:mm:ss";
    }
    return util.formatDate.format(new Date(cellValue),formate);
}


/**
 *检测是否是微信平台
 */
export function isWeiXin() {
    //平台、设备和操作系统  
    var system = { 
        win: false, 
        mac: false, 
        xll: false, 
        ipad: false
      }; 
      //检测平台  
      var p = navigator.platform; 
      system.win = p.indexOf("Win") == 0; 
      system.mac = p.indexOf("Mac") == 0; 
      system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
      system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false; 
      //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面  
      if (system.win || system.mac || system.xll || system.ipad) { 
        // alert("在PC端上打开的");
        return false;
      } else { 
        var ua = navigator.userAgent.toLowerCase();  
        if(ua.match(/MicroMessenger/i)=="micromessenger") {  
        //   alert("在手机端微信上打开的"); 
          return true; // 是微信端
        } else {  
        //   alert("在手机上非微信上打开的"); 
        return false;
        }  
      }

    // var ua = window.navigator.userAgent.toLowerCase();
    // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //     return true; // 是微信端
    // } else {
    //     return false;
    // }
}
